export default __webpack_public_path__ + "static/media/Shaka_particle_final_04.44d5165a.png";